// export type Role = "ADMINISTRATOR" | "MANAGER" | "EMPLOYEE" | "EDITOR";

export enum RoleEnum {
  ADMINISTRATOR = "ADMIN",
  MANAGER = "MANAGER",
  EMPLOYEE = "EMPLOYEE",
  EDITOR = "EDITOR",
  DELIVERYLEADER = "DELIVERY_LEADER",
}

export const ROLE_VALUES: readonly RoleEnum[] = Object.freeze([
  RoleEnum.ADMINISTRATOR,
  RoleEnum.MANAGER,
  RoleEnum.EMPLOYEE,
  RoleEnum.EDITOR,
  RoleEnum.DELIVERYLEADER,
]);

export function isRoleEnum(value: string): value is RoleEnum {
  return (ROLE_VALUES as readonly string[]).includes(value);
}
